export default "__VITE_ASSET__IRdm9Oem__"